import { themeQuartz } from "ag-grid-community";

export const workspaceGridTheme = themeQuartz.withParams({
  rowHeight: 32,
  headerHeight: 32,
  menuBackgroundColor: "var(--background)",
  headerBackgroundColor: "var(--background)",
  headerTextColor: "var(--muted-foreground)",
  fontFamily: "var(--font-sans)",
  wrapperBorderRadius: 0,
  wrapperBorder: { width: 0 },
});
